/*
 * @Author: 张印 hbzyin@163.com
 * @Date: 2023-07-27 19:21:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-12-19 10:43:52
 * @FilePath: /mall-fe/src/comps/MessageEntry.tsx
 * @Description: 消息入口文件
 *
 */
import { getAllUnreadNum } from 'api/user';
import IconFont from './IconFont';
import { UserContext } from 'libs/contexts';
import { BasePath } from 'libs/urls';
import { toQueryString } from 'libs/utils';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';
import { Badge } from 'react-vant';
import { MESSAGE_TYPE } from '@/views/h5/my-center/shared/constants';

/**
 *
 * @param {object} styles 消息体定制化样式
 * @returns
 */
export default function MessageEntry({ styles }: { styles?: any }) {
  const [total, setTotal] = useState(null);
  const userInfo = useContext(UserContext);
  const router = useRouter();

  useEffect(() => {
    (async () => {
      const param = {
        queryTotal: true,
        typeList: null,
      };
      const res = await getAllUnreadNum(param);
      setTotal(res?.data);
    })();
  }, []);

  return (
    <>
      <div
        className="badge-container"
        onClick={() => {
          const url = `/iframe-view${toQueryString({
            url: `/audit/pages/notice/index?msgType=${MESSAGE_TYPE.NOTICE}`,
            title: '消息中心',
            appKey: 'message',
          })}`;
          const returnUrl = encodeURIComponent(window.location.origin + BasePath + url);
          if (!userInfo) {
            router.push(
              `/login?return_url=${returnUrl}&back_url=${encodeURIComponent(location.href)}`,
            );
          } else {
            router.push(url);
          }
        }}
        style={styles}
      >
        <Badge content={total} max={99}>
          {IconFont({
            className: 'icon-mobile-footer-nav-message',
            style: {
              color: '#fff',
              fontSize: '20px',
            },
          })}
        </Badge>
      </div>

      <style jsx global>{`
        .badge-container {
          padding-left: 12px;
          padding-right: 8px;
        }
      `}</style>
    </>
  );
}
